import React from 'react';
import useCurrentPage from '../../../hooks/useCurrentPage';
import ContactForm from './ContactForm';

const ContactFormWrapper = (props) => {
  const {
    primaryColorClass,
    secondaryColorBackgroundClass,
    primaryColorBackgroundHoverClass,
    buttonStyleClass,
  } = useCurrentPage();

  return (
    <ContactForm
      primaryColorClass={primaryColorClass}
      secondaryColorBackgroundClass={secondaryColorBackgroundClass}
      primaryColorBackgroundHoverClass={primaryColorBackgroundHoverClass}
      buttonStyleClass={buttonStyleClass}
      {...props}
    />
  );
};

export default ContactFormWrapper;
